import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const ContactInfoSummary = ({ contactInfoSummary }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} pt="1" sx={{ fontSize: "14px" }}>
      <Grid item xs={4} sm={4} md={4}>
        <strong>{t("Partner.MobilePhone")}</strong> :{" "}
        <span>{contactInfoSummary ? contactInfoSummary.defaultPhone : ""}</span>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <strong>{t("Partner.Email")}</strong> : <span>{contactInfoSummary ? contactInfoSummary.defaultEmail : ""}</span>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <strong>{t("ContactInfo.ContactPerson")}</strong> :{" "}
        <span>{contactInfoSummary ? contactInfoSummary.defaultContactInfo : ""}</span>
      </Grid>
    </Grid>
  );
};

ContactInfoSummary.propTypes = {
  contactInfoSummary: PropTypes.object
};

export default ContactInfoSummary;
